const dev = {
  base_url: "http://localhost:4000/api",
  pre_app_fee_ru: "http://localhost:4000/api/billdesk_payments",
  payment_ru: "http://localhost:4000/api/billdesk_payments/application",
  billdesk_url: "https://staging-cnb-api.vidya-realm.info/api/initiate_payment",
  billdesk_sdk_url: "https://uat1.billdesk.com/u2/web/v1_2/embeddedsdk",
  enable_otp: false,
  merchantid: "BDUAT2K602",
  program_addon_ru: "http://localhost:4000/api/billdesk_payments/addon",
  payment_option_prgm_addon_ru: "http://localhost:4000/api/billdesk_payments/application_addon_payments",
  getSplitPayment: function (amount) {
    return [
      {
        mercid: "UAT2K602C1",
        amount: getFixedAmount("Split", amount),
        customer_refid: `V2EcomTestCRID${Math.floor(
          100000000 + Math.random() * 900000000
        )}`,
        additional_info1: "NA",
        additional_info2: "NA",
        additional_info3: "NA",
        additional_info4: "NA",
        additional_info5: "NA",
        additional_info6: "NA",
        additional_info7: "NA",
      },
      {
        mercid: "UAT2K602C2",
        amount: getFixedAmount("Split", amount),
        customer_refid: `V2EcomTestCRID${Math.floor(
          100000000 + Math.random() * 900000000
        )}`,
        additional_info1: "NA",
        additional_info2: "NA",
        additional_info3: "NA",
        additional_info4: "NA",
        additional_info5: "NA",
        additional_info6: "NA",
        additional_info7: "NA",
      },
    ];
  },
};

const staging = {
  base_url: "https://staging-cnb-api.vidya-realm.info/api",
  pre_app_fee_ru:
    "https://staging-cnb-api.vidya-realm.info/api/billdesk_payments",
  payment_ru:
    "https://staging-cnb-api.vidya-realm.info/api/billdesk_payments/application",
  billdesk_url: "https://staging-cnb-api.vidya-realm.info/api/initiate_payment",
  billdesk_sdk_url: "https://uat1.billdesk.com/u2/web/v1_2/embeddedsdk",
  program_addon_ru: "https://staging-cnb-api.vidya-realm.info/api/billdesk_payments/addon",
  payment_option_prgm_addon_ru: "https://staging-cnb-api.vidya-realm.info/api/billdesk_payments/application_addon_payments",
  enable_otp: true,
  merchantid: "BDUAT2K602",
  getSplitPayment: function (amount) {
    return [
      {
        mercid: "UAT2K602C1",
        amount: getFixedAmount("Split", amount),
        customer_refid: `V2EcomTestCRID${Math.floor(
          100000000 + Math.random() * 900000000
        )}`,
        additional_info1: "NA",
        additional_info2: "NA",
        additional_info3: "NA",
        additional_info4: "NA",
        additional_info5: "NA",
        additional_info6: "NA",
        additional_info7: "NA",
      },
      {
        mercid: "UAT2K602C2",
        amount: getFixedAmount("Split", amount),
        customer_refid: `V2EcomTestCRID${Math.floor(
          100000000 + Math.random() * 900000000
        )}`,
        additional_info1: "NA",
        additional_info2: "NA",
        additional_info3: "NA",
        additional_info4: "NA",
        additional_info5: "NA",
        additional_info6: "NA",
        additional_info7: "NA",
      },
    ];
  },
};

const production = {
  base_url: "https://cnb-api.vidya-realm.com/api",
  pre_app_fee_ru: "https://cnb-api.vidya-realm.com/api/billdesk_payments",
  payment_ru:
    "https://cnb-api.vidya-realm.com/api/billdesk_payments/application",
  billdesk_url: "https://cnb-api.vidya-realm.com/api/initiate_payment",
  billdesk_sdk_url: "https://pay.billdesk.com/web/v1_2/embeddedsdk",
  program_addon_ru: "https://cnb-api.vidya-realm.com/api/billdesk_payments/addon",
  payment_option_prgm_addon_ru: "https://cnb-api.vidya-realm.com/api/billdesk_payments/application_addon_payments",
  enable_otp: true,
  merchantid: "CUBSASONLI",
  getSplitPayment: function (amount) {
    return [
      {
        mercid: "CUBSASONL1",
        amount: getFixedAmount("Direct", amount),
        customer_refid: `V2EcomTestCRID${Math.floor(
          100000000 + Math.random() * 900000000
        )}`,
        additional_info1: "NA",
        additional_info2: "NA",
        additional_info3: "NA",
        additional_info4: "NA",
        additional_info5: "NA",
        additional_info6: "NA",
        additional_info7: "NA",
      },
    ];
  },
};

function getFixedAmount(type, amount) {
  const fee = parseFloat(amount);
  if (isNaN(fee)) return "0.00";
  if (type == "Direct") return fee.toFixed(2); 
  if (type == "Split") return (fee / 2).toFixed(2);
}

export default production;